////////////////////////////////////////////
// SOLANA MOBILE WALLET ADAPTER — ANDROID APP-TO-APP CONNECT
////////////////////////////////////////////
//
// REGISTERS MWA AS A WALLET-STANDARD WALLET SO IT SELF-SURFACES IN
// useWallet().wallets ON ANDROID — NO CHANGE TO THE WalletProvider ADAPTER
// LIST. THIS IS WHAT MAKES "CONNECT" WORK IN A NORMAL ANDROID BROWSER (THE
// WALLET OPENS AS AN APP AND HANDS THE SIGNATURE BACK IN THE SAME TAB),
// INSTEAD OF BOUNCING THROUGH A WALLET'S IN-APP BROWSER.
//
// registerMwa IS A NO-OP OFF-ANDROID, OFF-HTTPS, AND UNDER SSR — SO iOS AND
// DESKTOP ARE UNAFFECTED (THEY KEEP EXTENSIONS / THE DEEPLINK SHEET).
import {
  createDefaultAuthorizationCache,
  createDefaultChainSelector,
  createDefaultWalletNotFoundHandler,
  registerMwa,
} from "@solana-mobile/wallet-standard-mobile";

// RUN-ONCE GUARD — STRICTMODE DOUBLE-INVOKES EFFECTS; DOUBLE REGISTRATION
// WOULD LIST THE WALLET TWICE
let armed = false;

export function armMwa() {

  if (armed) return;
  armed = true;

  try {
    registerMwa({
      // APP IDENTITY — SHOWN ON THE WALLET'S APPROVAL SHEET
      appIdentity: {
        name: "Fuze",
        uri: location.origin,
        icon: "/logo.png",
      },
      authorizationCache: createDefaultAuthorizationCache(),
      // BOTH CLUSTERS — THE URL PICKS THE ACTIVE NET PER PAGE; THE DEFAULT
      // SELECTOR PROMPTS/PICKS WHEN A WALLET SUPPORTS MORE THAN ONE
      chains: ["solana:mainnet", "solana:devnet"],
      chainSelector: createDefaultChainSelector(),
      onWalletNotFound: createDefaultWalletNotFoundHandler(),
    });
  } catch (e) {
    // NON-FATAL — OFF-ANDROID/OFF-SECURE-CONTEXT registerMwa SIMPLY SKIPS
    console.warn("MWA registration skipped", e);
  }
}
